import { Menu } from "antd";
import React, { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  SettingOutlined,
  UserOutlined,
  LockOutlined,
  BankOutlined,
  ControlOutlined,
  FileDoneOutlined,
  DashboardOutlined,
  TeamOutlined,
  IdcardOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { useSelector } from "react-redux";

const paths = [
  { path: "/settings/user-profile", key: "1" },
  { path: "/settings/change-password", key: "2" },
  { path: "/settings/business-profile", key: "10" },
  { path: "/settings/general", key: "11" },
  { path: "/settings/general/org-levels", key: "11" },
  { path: "/settings/general/plan-templates", key: "11" },
  { path: "/settings/general/plan-groups", key: "11" },
  { path: "/settings/general/designations", key: "11" },
  { path: "/settings/general/plan-attributes", key: "11" },
  { path: "/settings/general/scales", key: "11" },
  { path: "/settings/organization", key: "12" },
  { path: "/settings/unit", key: "12" },
  { path: "/settings/positions", key: "13" },
  { path: "/settings/users", key: "14" },
  { path: "/settings/perf-cycles", key: "15" },
  { path: "/settings/approvals", key: "16" },
  { path: "/settings/target-approvals", key: "17" },
  { path: "/settings/plan-approvals", key: "18" },
  { path: "/settings/bulk-plan-creator", key: "19" },
];

function SettingsSideMenu(props) {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  let curLocation = useLocation();
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[2] === "unit") {
        setMainKey("12");
      } else if (curLocation.pathname.split("/")[3] === "plan-templates") {
        setMainKey("11");
      }
    });
  }, [curLocation]);

  return (
    <>
      <div className={"text-white mt-6 " + (!props.collapsed && "px-4")}>
        <Link to="/home" className="text-gray-400 hover:text-white text-xs">
          {!props.collapsed ? (
            <div>
              <ArrowLeftOutlined /> Back
            </div>
          ) : (
            <div className="text-center mb-1">
              <ArrowLeftOutlined /> Back
            </div>
          )}
        </Link>
        {props.collapsed ? (
          <div className="text-center">
            <SettingOutlined className="text-xl" />
          </div>
        ) : (
          <div className="text-xl pri-font">Settings</div>
        )}
      </div>
      <Menu
        style={{
          height: proHeight - 142,
          overflow: "auto",
          marginTop: "20px",
        }}
        className="transparent-scroll "
        theme="dark"
        selectedKeys={[mainKey]}
        mode="inline"
        collapsed
      >
        <div
          className={
            "text-xs text-white " + (props.collapsed ? "text-center" : "pl-6")
          }
        >
          Pers<span style={{ display: props.collapsed && "none" }}>onal</span>
        </div>
        <Menu.Item key="1" icon={<UserOutlined />}>
          <Link to="/settings/user-profile">Your Profile</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<LockOutlined />}>
          <Link to="/settings/change-password">Change Password</Link>
        </Menu.Item>
        <div
          className={
            "text-xs text-white mt-6 " +
            (props.collapsed ? "text-center" : "pl-6")
          }
        >
          Org
          <span style={{ display: props.collapsed && "none" }}>anization</span>
        </div>
        {permissionAbility(userLevel, "general", "view") && (
          <Menu.Item key="11" icon={<ControlOutlined />}>
            <Link to="/settings/general">General</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "organization", "view") && (
          <Menu.Item key="12" icon={<BankOutlined />}>
            <Link to="/settings/organization">Organization</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "positions", "view") && (
          <Menu.Item key="13" icon={<IdcardOutlined />}>
            <Link to="/settings/positions">Positions</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "users", "view") && (
          <Menu.Item key="14" icon={<TeamOutlined />}>
            <Link to="/settings/users">Users</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "perf-cycles", "view") && (
          <Menu.Item key="15" icon={<DashboardOutlined />}>
            <Link to="/settings/perf-cycles">Perf cycles</Link>
          </Menu.Item>
        )}
        <Menu.Item key="16" icon={<FileDoneOutlined />}>
          <Link to="/settings/approvals">Approvals</Link>
        </Menu.Item>
        <Menu.Item key="17" icon={<FileDoneOutlined />}>
          <Link to="/settings/target-approvals">Target Approvals</Link>
        </Menu.Item>
        <Menu.Item key="18" icon={<FileDoneOutlined />}>
          <Link to="/settings/plan-approvals">Plans Approvals</Link>
        </Menu.Item>
        <Menu.Item key="19" icon={<FileAddOutlined />} style={{ display: 'none' }}>
          <Link to="/settings/bulk-plan-creator">Bulk Plan Creator</Link>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default SettingsSideMenu;
